export async function loadResources(siteId, httpInstance) {
    try {
        const resources = await httpInstance.get("/api/myconfig/calendar/resources", {
      params: {
        siteId
      }
    });
    return resources?.data?.data || [];
  } catch (error) {
    console.error('Erro ao buscar recursos', error);
    return [];
  }
  }